import styled from 'styled-components';
import { sizes, fadeIn } from 'style';
import { th } from 'style/theme';

export const Background = styled.div<{ bg: string }>`
  position: relative;
  min-height: 100vh;
  height: 100%;
  background-color: ${({ bg }) => th(`colors.${bg}`)};
  padding: 20px;
  padding-top: 80px;
  font-family: 'Helvetica Now';

  @media ${sizes.desktop} {
    padding: 44px 40px;
    padding-top: 120px;
  }
`;

export const StyledContainer = styled.div`
  animation: ${fadeIn} 0.25s linear;

  @media ${sizes.desktop} {
    max-width: 1220px;
    margin: 0 auto;
  }
`;
